import type { SaveData } from '@/domains/onboarding/types';

export interface OnboardingService {
    save(data: SaveData): Promise<boolean>;
    info(): Promise<SaveData>;
}

export const OnboardingService = Symbol('OnboardingService');
